import { ITextAreaStyle, TextAlignKinds } from "../../../../base/domain/drawing";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";


export interface ITextStylePropertyEditable {
  textStyle(): IPropertyEditable<ITextAreaStyle>;
  getSelectableAlignmentKinds(): TextAlignKinds[];
}

export function instanceOfITextStylePropertyEditable(instance: any): instance is ITextStylePropertyEditable {
  return instance
      && instance.textStyle
      && instance.getSelectableAlignmentKinds
      && instanceOfIPropertyEditable<ITextAreaStyle>(instance.textStyle());
}
